import GenericErrorDisplay from "../../generic-error";
import SectionDescriere from "./section-descriere";
import SectionIstoric from "./section-istoric";
import SectionStatutRoi from "./section-statut-roi";
import SectionStructura from "./section-structura";
import "./styles.css";
import { useLoaderData, useRouteError } from "react-router-dom";
import SectionAsociatii from "./section-asociatii/index.jsx";
import { OutputStructureGroup } from "../../../dtos/structure";
import ResourceDisplay from "../../../components/resource-display";
import ResourceService from "../../../service/resource";
import PersonService from "../../../service/person";
import StructureService from "../../../service/structure";

const resourceKeys = {
  pageTitle: "about-index-description-title",
  descriptionText: "about-index-description-text",
  finalImage: "about-index-final-element",
  logoFasmrSimpleBlue: "logo-fasmr-simple-blue",

  historyTitle: "about-index-history-title",
  historyText: "about-index-history-text",

  documentsCover: "about-index-documents-picture",
  documentsFirstText: "about-index-documents-first-text",

  documentsStatutTitle: "about-index-documents-statut-title",
  documentsStatutText: "about-index-documents-statut-text",
  documentsStatutIcon: "about-index-documents-statut-icon",

  documentsRoiTitle: "about-index-documents-roi-title",
  documentsRoiText: "about-index-documents-roi-text",
  documentsRoiIcon: "about-index-documents-roi-icon",

  structureTitle: "about-index-structure-title",

  structureCdTitle: "about-index-structure-cd-title",
  structureCdText: "about-index-structure-cd-text",

  structureCommitteesTitle: "about-index-structure-committees-title",
  structureCommitteesText: "about-index-structure-committees-text",

  structureDivisionsTitle: "about-index-structure-divisions-title",
  structureDivisionsText: "about-index-structure-divisions-text",

  structureProjectsTitle: "about-index-structure-projects-title",
  structureProjectsText: "about-index-structure-projects-text",

  membersTitle: "about-index-members-title",
  membersText: "about-index-members-text",
  membersFullTitle: "about-index-members-full-title",
  membersObsTitle: "about-index-members-obs-title",
};

export async function loader({ request }) {
  const resources = new ResourceService().read.byIds(
    Object.values(resourceKeys)
  );
  const cdPeople = new PersonService().read.byGroup("cd");
  const structureReader = new StructureService().read;
  const committees = structureReader.byGroup(OutputStructureGroup.committee);
  const divisions = structureReader.byGroup(OutputStructureGroup.division);
  const projects = structureReader.byGroup(OutputStructureGroup.project);
  const membersFull = structureReader.byGroup(
    OutputStructureGroup["member-full"]
  );
  const membersObs = structureReader.byGroup(
    OutputStructureGroup["member-obs"]
  );

  return [
    await resources,
    await cdPeople,
    await committees,
    await divisions,
    await projects,
    await membersFull,
    await membersObs,
  ];
}

export function Component() {
  const [
    resources,
    cdPeople,
    committees,
    divisions,
    projects,
    membersFull,
    membersObs,
  ] = useLoaderData();

  return (
    <div id="page-despre-noi">
      <h4 className="motto">
        Împreună facem în continuare <span>diferența!</span>
      </h4>
      <SectionDescriere
        title={resources[resourceKeys.pageTitle]}
        text={resources[resourceKeys.descriptionText]}
        logo={resources[resourceKeys.logoFasmrSimpleBlue]}
      />
      <SectionIstoric
        title={resources[resourceKeys.historyTitle]}
        text={resources[resourceKeys.historyText]}
      />
      <SectionStatutRoi
        cover={resources[resourceKeys.documentsCover]}
        firstText={resources[resourceKeys.documentsFirstText]}
        statut={[
          resources[resourceKeys.documentsStatutTitle],
          resources[resourceKeys.documentsStatutText],
          resources[resourceKeys.documentsStatutIcon],
        ]}
        roi={[
          resources[resourceKeys.documentsRoiTitle],
          resources[resourceKeys.documentsRoiText],
          resources[resourceKeys.documentsRoiIcon],
        ]}
      />
      <SectionStructura
        title={resources[resourceKeys.structureTitle]}
        cd={[
          resources[resourceKeys.structureCdTitle],
          resources[resourceKeys.structureCdText],
          cdPeople,
        ]}
        committees={[
          resources[resourceKeys.structureCommitteesTitle],
          resources[resourceKeys.structureCommitteesText],
          committees,
        ]}
        divisions={[
          resources[resourceKeys.structureDivisionsTitle],
          resources[resourceKeys.structureDivisionsText],
          divisions,
        ]}
        projects={[
          resources[resourceKeys.structureProjectsTitle],
          resources[resourceKeys.structureProjectsText],
          projects,
        ]}
      />
      <div
        className="container-wrapper"
        style={{
          height: "var(--gap-xl)",
          backgroundColor: "var(--color-light)",
        }}
      />
      <SectionAsociatii
        title={resources[resourceKeys.membersTitle]}
        text={resources[resourceKeys.membersText]}
        members={[
          resources[resourceKeys.membersFullTitle],
          membersFull,
          resources[resourceKeys.membersObsTitle],
          membersObs,
        ]}
      />
      <div
        className="container-wrapper last-image"
        style={{ backgroundColor: "var(--color-gray-light)" }}
      >
        <div className="container">
          <ResourceDisplay
            resource={resources[resourceKeys.finalImage]}
            className="resource"
          />
        </div>
      </div>
    </div>
  );
}
Component.displayName = "page-about";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-about-error";
